export const cleanSeparators = (items) =>
{
    const clean = [];

    items.forEach((x, i) => {
        if (i === 0 && x.separator)
            return null;

        if (i === items.length - 1 && x.separator)
            return null;

        if (i > 0 && x.separator && items[i - 1].separator)
            return null;

        clean.push(x);    
    })

    return clean;
}


// WEBPACK FOOTER //
// ./src/fw/components/menu/Utils.js